import styled from "styled-components";

export const Wrapper = styled.div`
  z-index: 200;
  width: 100%;
  display: flex;
  align-items: center;
`;

export const CustomSearchInput = styled.input`
  width: 15.45rem;
  height: 2rem;
  font-size: 0.75rem;
  border: 1px solid #40e5a0;
  box-shadow: 0px 0px 0.5rem rgba(64, 229, 160, 0.3);
  border-radius: 0.25rem;
  padding-left: 2.65rem;
  outline: none;
  color: #212326;
`;

export const DivIcon = styled.div`
  display: flex;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0.625rem;
`;
export const DataResult = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 2.5rem;
  left: 0;
  background: #ffffff;
  border: 1px solid #d4d6da;
  border-radius: 0.25rem;
  width: 17.45rem;
  overflow-y: auto;
  max-height: calc(3 * 4rem);

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: #eff1f5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #a9aeb4;
    border-radius: 20px;
    border: none;
  }
`;

export const ListItem = styled.div`
  display: flex;
  width: 100%;
  min-height: 4rem;
  align-items: center;

  cursor: pointer;
  &:hover {
    background: #d6e5fa;
  }
`;

export const Avatar = styled.img`
  display: flex;
  background: lightblue;
  max-width: 1.875rem;
  max-height: 1.875rem;
  border-radius: 50%;
  margin-left: 0.625rem;
`;
export const InfoUser = styled.div`
  display: flex;
  user-select: none;
  flex-direction: column;
  margin-left: 0.5416rem;

  //margem + largura dos elementos anteriores
  width: calc(15.45rem - 1.25rem - 0.625rem - 0.5416rem);
`;
export const Name = styled.span`
  font-size: 0.75rem;
  color: #212326;
  line-height: 0.945rem;
  width: 100%;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const Email = styled.span`
  font-size: 0.6875rem;
  color: #7e858f !important;
  line-height: 0.86625rem;

  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
